export interface Colors {
  earthYellow: string;
  brownYellow: string;
  burntSienna: string;
  pastelRed: string;
  white: string;
  black: string;
  black50: string;
}

const colors = {
  earthYellow: '#e3a264',
  brownYellow: '#CC9966',
  burntSienna: '#E86B4D',
  pastelRed: '#FF6666',
  white: '#FFF',
  black: '#000',
  black50: 'rgba(0, 0, 0, 0.5)',
};

export default colors;
